import { toast } from "../../../../core/helpers/message-helper";
import { Row, Col, Card, CardBody, Container } from "reactstrap";
import { useEffect, useState } from "react";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import {
    selectTipoSolicitudPorArea,
} from "../../../../core/services/areas-service";
import { useNavigate, useOutletContext } from "react-router-dom";

const TiposSolicitudes = () => {
    const [tiposSolicitudes, setTiposSolicitudes] = useState([]);
    const navigate = useNavigate();
    const { area, setTipoSolicitud } = useOutletContext();

    useEffect(async () => {
        if (area == null) {
            navigate("/solicitudes/ciudades");
        }
        const resp = await selectTipoSolicitudPorArea(area.id);
        if (!resp.status) return toast.error(resp.message);
        setTiposSolicitudes(resp.data);
    }, []);

    function onClickTipoSolicitud(tipoSolicitud) {
        setTipoSolicitud(tipoSolicitud);
        if (tipoSolicitud.abreviacion == "Soporte") {
            navigate("/solicitudes/soporte");
        }
    }

    return (
        <ContentWrapper>
            <div className="d-sm-flex align-items-center justify-content-center mb-4">
                <div className="h3 mb-0 text-purple-mac">
                    <i className="fas fa-city"></i> Tipos de solicitudes
                </div>
            </div>
            <Row>
                {tiposSolicitudes.map(function (tipoSolicitud) {
                    const style = {
                        cursor: "pointer",
                    };
                    return (
                        <Col md="4" key={tipoSolicitud.id}>
                            <Container
                                className="row justify-content-center align-items-center"
                                width="80"
                            >
                                <Card
                                    style={style}
                                    className="border-left-primary shadow h-100 hvr-grow"
                                    onClick={function () {
                                        onClickTipoSolicitud(tipoSolicitud);
                                    }}
                                >
                                    <CardBody>
                                        <div className="row">
                                            <div className="col-8">
                                                <p className="h4 font-weight-bold text-primary text-uppercase mb-2 text-left">
                                                    {tipoSolicitud.nombre}
                                                </p>
                                                <p className="h5 font-weight-bold text-secondary text-uppercase mb-2 text-left">
                                                    {tipoSolicitud.descripcion}
                                                </p>
                                            </div>
                                            <div className="col-4">
                                                <img
                                                    className="rounded-circle"
                                                    width="80"
                                                    height="80"
                                                    src="img/logo_csr_big.png"
                                                />
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Container>
                        </Col>
                    );
                })}
            </Row>
        </ContentWrapper>
    );
};

export default TiposSolicitudes;
